module.exports = __webpack_public_path__ + "957186ef505a08de512d5e29b54a2c06.svg";